import type { Template, TemplateSection, SectionType } from '@/models/template';

const DEFAULT_ORDER: SectionType[] = [
  'TAGS',
  'FOLLOW_UP',
  'CONTEXT',
  'MEASUREMENTS',
  'FINDINGS',
  'CONCLUSION',
  'SIGNATURES',
];

/**
 * Returns an ordered list of sections from the template.
 * Falls back to a hardcoded default when the template has no sections array.
 */
export function buildSectionOrder(
  template: Template | undefined
): TemplateSection[] {
  if (template?.sections && template.sections.length > 0) {
    return [...template.sections].sort((a, b) => a.index - b.index);
  }

  return DEFAULT_ORDER.map((sectionType, i) => ({
    createdAt: '',
    groups: [],
    index: i,
    sectionType,
    updatedAt: '',
    uuid: sectionType,
  }));
}
